import classNames from 'classnames';
import * as React from 'react';

import { useNavbarSchema } from 'bones/components/molecules/Navbar/context/NavbarSchema';
import { NavbarAvatar } from 'bones/components/molecules/Navbar/navbar/NavbarAvatar';
import { NavbarButton } from 'bones/components/molecules/Navbar/navbar/NavbarButton';
import { NavbarDropdown } from 'bones/components/molecules/Navbar/navbar/NavbarDropdown';
import { NavbarExpand } from 'bones/components/molecules/Navbar/navbar/NavbarExpand';

export const Navbar: React.VFC = () => {
  const { expand, primaryItems, secondaryItems, tertiaryItems, footer } =
    useNavbarSchema();

  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);

  return (
    <div
      className={classNames('vb-navbar', {
        'vb-navbar--collapsed': !expand.isExpanded,
        'vb-navbar--expanded': expand.isExpanded,
      })}
      onMouseLeave={() => {
        setIsDropdownOpen(false);
      }}
    >
      <NavbarDropdown
        isDropdownOpen={isDropdownOpen}
        setIsDropdownOpen={setIsDropdownOpen}
      />
      {primaryItems?.length ? (
        <>
          <div className="vb-navbar-primary">
            {primaryItems?.map((item) => (
              <NavbarButton
                key={item.label || /* istanbul ignore next */ item.testId}
                item={item}
                variant="dark-secondary"
              />
            ))}
          </div>
          <div className="vb-navbar-divider" />
        </>
      ) : null}
      <div className="vb-navbar-grow">
        <div className="vb-navbar-secondary">
          {secondaryItems?.map((item) => (
            <NavbarButton
              key={item.label || /* istanbul ignore next */ item.testId}
              item={item}
              variant="dark-tertiary"
            />
          ))}
        </div>
        <div className="vb-navbar-tertiary">
          {tertiaryItems?.map((item) => (
            <NavbarButton
              key={item.label || /* istanbul ignore next */ item.testId}
              item={item}
              variant="dark-ghost-gray"
            />
          ))}
        </div>
      </div>
      {footer?.avatar || footer?.items?.length ? (
        <>
          <div className="vb-navbar-divider" />
          <div className="vb-navbar-footer">
            {footer.items?.map((item) => (
              <NavbarButton
                key={item.label || /* istanbul ignore next */ item.testId}
                item={item}
                variant="dark-ghost-gray"
              />
            ))}
            <NavbarAvatar />
          </div>
        </>
      ) : null}
      <NavbarExpand />
    </div>
  );
};
